import { useRevalidator, useResolvedPath } from "@remix-run/react";
import { useEffect } from "react";
import { useTypedLoaderData } from "remix-typedjson";
import { useEventSource } from "remix-utils/sse/react";
import { route } from "~/utils/route";

export function useLiveLoaderData<T>() {
  let path = useResolvedPath(route("/admin/calendar/stream"));
  let data = useEventSource(path.pathname);

  let { revalidate } = useRevalidator();

  useEffect(() => {
    revalidate();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- "we know better" — Moishi
  }, [data]);

  return useTypedLoaderData<T>();
}

export function useLiveRevalidator() {
  let path = useResolvedPath(route("/admin/calendar/stream"));
  let data = useEventSource(path.pathname);

  let { revalidate } = useRevalidator();

  useEffect(() => {
    revalidate();

    // whenever the window is focused, revalidate the data
    window.addEventListener("focus", revalidate);

    // also just to be safe, revalidate every 5 minutes
    let interval = setInterval(revalidate, 5 * 60 * 1000);

    return () => {
      window.removeEventListener("focus", revalidate);
      clearInterval(interval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps -- "we know better" — Moishi
  }, [data]);

  return null;
}
